import { Auth0Client } from "@auth0/auth0-spa-js";
import axios from "axios";
import { apiConfig, auth0Config } from "../../config";
import querySearchEndpoint from "../../utils/querySearchEndpoint";
import {
  CreateEncounterTemplatePreference,
  EncounterTemplate,
  EncounterTemplatePreference,
} from "../../types/templates";

const urlPath = "templates";

class TemplateApi {
  private auth0Client: Auth0Client | null = null;

  constructor() {
    this.auth0Client = new Auth0Client({
      redirect_uri: window.location.origin,
      ...auth0Config,
    });
  }

  async getAuthToken() {
    return this.auth0Client?.getTokenSilently();
  }

  async getTemplateByVersion(id: string, version: number) {
    const authToken = await this.auth0Client.getTokenSilently();
    const config = { headers: { Authorization: `Bearer ${authToken}` } };
    return axios
      .get<EncounterTemplate>(
        `${apiConfig.medicalsServiceBase}/${urlPath}/version/${id}/${version}`,
        config,
      )
      .then((res) => res.data);
  }

  async getTemplatePreferences(query: Record<string, unknown>) {
    const authToken = await this.auth0Client.getTokenSilently();
    const config = { headers: { Authorization: `Bearer ${authToken}` } };
    const url = new URL(
      `${apiConfig.medicalsServiceBase}/${urlPath}/preferences`,
    );
    try {
      return await querySearchEndpoint(url, query, config);
    } catch (error) {
      if (error?.response?.status === 403) {
        console.error("Insufficient Permissions - Cannot Read Templates");
        return [];
      }
      throw error;
    }
  }

  async saveTemplatePreference(
    formData: CreateEncounterTemplatePreference,
    headers: Record<string, string> = {},
  ) {
    const authToken = await this.auth0Client.getTokenSilently();
    const config = {
      headers: { Authorization: `Bearer ${authToken}`, ...headers },
    };
    return axios
      .post<EncounterTemplatePreference>(
        `${apiConfig.medicalsServiceBase}/${urlPath}/preferences`,
        formData,
        config,
      )
      .then((res) => res.data);
  }
}
const templateApi = new TemplateApi();

export default templateApi;
